import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { FormatMoney } from '../../utils/formatMoney'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { convert } from '../../utils/convertDate'; // Import convert function
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import TreasuryBillClass from '../../services/treasuryBill';
import { toast } from 'react-toastify';
import { BsMinecartLoaded } from 'react-icons/bs';
import BackButton from '../../components/BackButton';
import Modal from '../../components/Modals/Modal';

// utils/formatMoney.ts
export const formatMoney = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  const cleaned = stringValue.replace(/\D/g, ''); // remove non-numeric
  if (!cleaned) return '';
  return new Intl.NumberFormat('en-NG').format(parseInt(cleaned, 10));
};


const CreateEditTreasuryBills = () => {
  const location = useLocation();
  const { slug } = useParams(); // Get slug from URL parameters (if used)
  const queryParams = new URLSearchParams(location.search); // Get query parameters
  const tBillIdFromQuery = queryParams.keys().next().value; // Get the first query parameter key, which is the T-Bill ID
  
  const currentMode = location.pathname.includes('/treasury/view') ? 'view' : (location.pathname.includes('/treasury/edit') ? 'edit' : 'create');
  const isViewMode = currentMode === 'view'; // Changed to only be true for 'view' mode

  const [tBillId, setTBillId] = useState("");
  const [inputVolume, setInputVolume] = useState('');
  const [inputTenor, setInputTenor] = useState('');
  const [discountRate, setDiscountRate] = useState('');
  const [maturityDate, setMaturityDate] = useState(new Date()); // Initialize with a valid date
  const [redemptionValue, setRedemptionValue] = useState('');
  const [yieldValue, setYieldValue] = useState('');
  const [adminType, setAdminType] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalModalTitle, setApprovalModalTitle] = useState("");
  const [approvalModalText, setApprovalModalText] = useState("");
  const [pendingApprovalAction, setPendingApprovalAction] = useState(null); // 'approve' or 'reject'

  const [treasuryData, setTreasuryData] = useState({
    createdBy: "",
    dateCreated: null,
    dateDeleted: null,
    dateModified: null,
    deletedBy: "",
    discountRate: null,
    id: null,
    isDeleted: null,
    maturityDate: null,
    modifiedBy: "",
    redemptionValue: null,
    status: "",
    tBillID: "",
    tenantId: "",
    tenor: null,
    volume: null
  }
  )

  const [isLoading, setIsLoading] = useState(false)
  const [isListLoading, setISListLoading] = useState(false)
  const [isApproving, setIsApproving] = useState(false)
  const [isRejecting, setIsRejecting] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const GetListings = async () => {
      setISListLoading(true)
        try {
            const response = await TreasuryBillClass.getTreasuryBillById(parseInt(tBillIdFromQuery));
            console.log("listing", response)
           if(response){
            const data = response.data;
            console.log("response", data)
            setTreasuryData(data)
            setTBillId(data.tBillID);
            setInputVolume(data.volume);
            setInputTenor(data.tenor);
            setDiscountRate(String(data.discountRate).replace('%', ''));
            setMaturityDate(new Date(convert(data.maturityDate))); // Use convert function here
            setRedemptionValue(data.redemptionValue);
            setISListLoading(false)
            // setYieldValue(data.yield.replace('%', ''));
           }
        } catch (error) {
            console.error("Error fetching treasury bills:", error);
            setISListLoading(false)
        } finally {
          setISListLoading(false)
        }
    }
   if(slug != "create"){
    GetListings();
   }
  }, [slug, tBillIdFromQuery])

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }, [slug])

  const handleSaveInternal = async () => {
    setIsLoading(true)
    
    // Client-side validation - REMOVED from here
    // if (!tBillId || !inputVolume || !inputTenor || !discountRate || !maturityDate || !redemptionValue) {
    //   toast.error("Please fill in all required fields.");
    //   setIsLoading(false);
    //   return;
    // }

    // Format date to avoid timezone issues
    const formatDateForBackend = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00`;
    };

    const treasuryRequest = {
        tBillID: tBillId,
        volume: parseFloat(inputVolume),
        tenor: parseInt(inputTenor),
        discountRate: parseFloat(discountRate),
        maturityDate: formatDateForBackend(maturityDate),
        redemptionValue: parseFloat(redemptionValue)
    }

    console.log("treasuryRequest", treasuryRequest)
    try {
      
      if(slug === "edit"){
        const response = await TreasuryBillClass.updateTreasuryBillListtings({...treasuryRequest,
          treasuryBillListingID: parseInt(tBillIdFromQuery)
         })
        if(response){
          // setIsLoading(false)
          // window.location.reload()
          toast.success("Bond Updated")
          setIsLoading(false)
         setTimeout(() => {
          window.location.reload()
         }, 2000);
        }
      } else {
        console.log("treasuryRequest create", treasuryRequest)
        const response = await TreasuryBillClass.CreateTreasuryBillListtings(treasuryRequest);
        console.log("natural", response)
        if(response){
          console.log("done", response)
          toast.success(response.message)
          setTimeout(() => {
            setIsLoading(false)
            navigate("/treasury")
          }, 2000);
        } else {
          setIsLoading(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
      setISListLoading(false)
    } finally {
      setIsLoading(false)
      setISListLoading(false)
    }
    // Implement nasave logic here
  };

  const confirmChanges = async () => {
    // Client-side validation - MOVED to here
    if (!tBillId || !inputVolume || !inputTenor || !discountRate || !maturityDate || !redemptionValue) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setShowConfirmationModal(true);
  };

  const handleConfirm = async () => {
    setShowConfirmationModal(false);
    await handleSaveInternal(); // Call the actual save logic
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
    setIsLoading(false);
  };

  const handleApprove = async (injunction) => {
    setPendingApprovalAction(injunction);
    setApprovalModalTitle(injunction === 'approve' ? "Confirm Approval" : "Confirm Rejection");
    setApprovalModalText(injunction === 'approve' ? "Are you sure you want to approve this T-Bill creation?" : "Are you sure you want to reject this T-Bill creation?");
    setShowApprovalModal(true);
  };

  const handleApproveConfirm = async () => {
    setShowApprovalModal(false);
    // Set the appropriate loading state based on the action
    if (pendingApprovalAction === 'approve') {
      setIsApproving(true);
    } else if (pendingApprovalAction === 'reject') {
      setIsRejecting(true);
    }
    try {
      const response = await TreasuryBillClass.approveRejectTreasuryBill(treasuryData.id, pendingApprovalAction);
      if(response){
        toast.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error("Error during approval/rejection:", error);
      setIsApproving(false);
      setIsRejecting(false);
    }
  };

  const handleApprovalCancel = () => {
    setShowApprovalModal(false);
    setPendingApprovalAction(null);
    setIsApproving(false);
    setIsRejecting(false);
  }

  if(isListLoading){
    return (
      <div className='min-h-full w-full'>
        <div>
          <BsMinecartLoaded className='animate-spin duration-500 transition ease-in-out' />
        </div>
      </div>
    )
  }

 if(treasuryData && !isListLoading){
  const isInitiated = treasuryData.status?.toLowerCase() === "initiated";
  const isRejected = treasuryData.status?.toLowerCase() === "rejected";
  const isReadOnly = isViewMode || isInitiated || isRejected;
  
  return (
    <Layout title={isViewMode ? "View T-Bill" : (currentMode === 'edit' ? "Edit T-Bill" : "Create T-Bill")} pageTag={"treasury_bill"} current={'/treasury/create'}>
      <React.Fragment>
        <div className="min-h-full">
          <div className="flex flex-1 flex-col">
           <div className={`flex items-center justify-between w-full pr-10 font-bold`}>
              <BackButton />
              <h1 className={` ${treasuryData.status.toLowerCase() === "initiated" ? "text-blue-500" : treasuryData.status.toLowerCase() === "rejected" ? "text-red-500" : "text-green-500"}`}>{treasuryData.status}</h1>
           </div>
            <main className="flex-1">
              <div className="py-6">
                <div className="">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
                        {/* T-Bill ID */}
                        <div>
                          <label htmlFor="tBillId" className="block text-sm font-medium text-gray-700">T-Bill ID</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="tBillId"
                              id="tBillId"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={tBillId}
                              onChange={!isReadOnly ? (e) => setTBillId(e.target.value) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter T-Bill ID"
                              required
                            />
                          </div>
                        </div>

                        {/* Input Volume */}
                        <div>
                          <label htmlFor="inputVolume" className="block text-sm font-medium text-gray-700">Volume</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="inputVolume"
                              id="inputVolume"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={inputVolume ? formatMoney(inputVolume) : ''}
                              onChange={!isReadOnly ? (e) => {
                                const rawValue = e.target.value.replace(/,/g, '').replace(/\D/g, ''); 
                                setInputVolume(rawValue);
                              } : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Input Volume"
                              required
                            />

                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm" id="price-currency">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Input Tenor */}
                        <div>
                          <label htmlFor="inputTenor" className="block text-sm font-medium text-gray-700">Tenor</label>
                          <div className="mt-1">
                            <input
                              type="number"
                              name="inputTenor"
                              id="inputTenor"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={inputTenor}
                              onChange={!isReadOnly ? (e) => setInputTenor(e.target.value) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Tenor"
                              required
                            />
                          </div>
                        </div>

                        {/* Discount rate */}
                        <div>
                          <label htmlFor="discountRate" className="block text-sm font-medium text-gray-700">Discount rate</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="discountRate"
                              id="discountRate"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${discountRate}%`}
                              onChange={!isReadOnly ? (e) => setDiscountRate(e.target.value.replace('%', '')) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Discount Rate"
                              required
                            />
                          </div>
                        </div>

                        {/* Maturity Date */}
                        <div>
                          <label htmlFor="maturityDate" className="block text-sm font-medium text-gray-700">Maturity Date</label>
                          <div className="mt-1">
                            <DatePicker
                              onChange={!isReadOnly ? setMaturityDate : undefined}
                              value={maturityDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={isReadOnly}
                              calendarClassName="placeholder-gray-400"
                              required
                            />
                          </div>
                        </div>

                        {/* Redemption Value */}
                        <div>
                          <label htmlFor="redemptionValue" className="block text-sm font-medium text-gray-700">Redemption Value</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="redemptionValue"
                              id="redemptionValue"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={redemptionValue ? formatMoney(redemptionValue) : ''}
                              onChange={!isReadOnly ? (e) => {
                                const rawValue = e.target.value.replace(/,/g, '').replace(/\D/g, ''); 
                                setRedemptionValue(rawValue);
                              } : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Redemption Value"
                              required
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Yield */}
                        {/* <div className={`${currentMode === "create" && "hidden"}`}>
                          <label htmlFor="yieldValue" className="block text-sm font-medium text-gray-700">Yield</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="yieldValue"
                              id="yieldValue"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${treasuryData.redemptionValue}%`}
                              onChange={!isViewMode ? (e) => setYieldValue(e.target.value.replace('%', '')) : undefined}
                              readOnly={isViewMode}
                              placeholder="Enter Yield Value"
                            />
                          </div>
                        </div> */}
                      </div>

                     {
                      currentMode !== "view" && !isInitiated && !isRejected &&  
                      <div className="mt-6 flex justify-end">
                        <button
                          type="button"
                          onClick={confirmChanges}
                          className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                         {
                          isLoading ? "Loading..." : "Save Changes"
                         }
                        </button>
                      </div>
                     }
                     {
                      currentMode !== "view" && isInitiated && adminType.toLowerCase() === "checker" &&  
                      <div className="mt-6 flex justify-end">
                        <button
                          type="button"
                          onClick={handleSaveInternal}
                          className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                         {
                          isLoading ? "Loading..." : "Approve Changes"
                         }
                        </button>
                      </div>
                     }

{
                      currentMode === "view" && adminType.toLowerCase() === "checker" && isInitiated && <div className="mt-6 flex justify-end">
                      <button
                        type="button"
                        onClick={() => handleApprove("approve")}
                        disabled={isApproving || isRejecting}
                        className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                       {
                        isApproving ? "Loading..." : "Approve T-Bill Creation"
                       }
                      </button>
                      <button
                        type="button"
                        onClick={() => handleApprove("reject")}
                        disabled={isApproving || isRejecting}
                        className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                       {
                        isRejecting ? "Loading..." : "Reject T-Bill Creation"
                       }
                      </button>
                    </div>
                     }
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </React.Fragment>
      {/* Confirmation Modal */}
      <Modal
        isOpen={showConfirmationModal}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        modalTitle={currentMode === 'create' ? "Confirm T-Bill Creation" : "Confirm Changes"}
        modalText={currentMode === 'create' ? "Are you sure you want to create this T-Bill?" : "Are you sure you want to save these changes?"}
      />

      {/* Approval/Rejection Modal */}
      <Modal
        isOpen={showApprovalModal}
        onClose={handleApprovalCancel}
        onConfirm={handleApproveConfirm}
        onCancel={handleApprovalCancel}
        modalTitle={approvalModalTitle}
        modalText={approvalModalText}
      />
    </Layout>
  )
 }

 if(!treasuryData && !isLoading){
  return (
    <div>No data available</div>
  )
 }
}

export default CreateEditTreasuryBills